class AiTier {
    constructor(
        public id?: string,
        public name?: string,
        public maxCreditsPerMonth?: number
    ) {
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const entity = new AiTier();

        entity.id = data.id;
        entity.name = data.name;
        entity.maxCreditsPerMonth = data.maxCreditsPerMonth;

        return entity;
    }
}

export default AiTier;
